import { AfterViewInit, Component, ElementRef, Input, OnChanges, OnInit, SimpleChanges, ViewChild } from '@angular/core';
import { PanZoomConfig, PanZoomAPI, PanZoomModel, PanZoomConfigOptions } from 'ngx-panzoom';
import { Subscription } from 'rxjs';
import * as d3 from 'd3';
import { MaskingService } from '@services/masking.service';
import { DomSanitizer } from '@angular/platform-browser';
import { Router } from '@angular/router';

@Component({
  selector: 'app-preview-hotspot-question',
  templateUrl: './preview-hotspot-question.component.html',
  styleUrls: ['./preview-hotspot-question.component.scss']
})
export class PreviewHotspotQuestionComponent implements OnInit, OnChanges, AfterViewInit {

  @Input() questions: any;
  @Input() isReadOnly: boolean;
  @Input() displayMode: string;
  @ViewChild('artboard', { static: true }) artboard: ElementRef<HTMLDivElement>;
  public svg;
  allPoints: any[] = []
  points = []
  public color1: string = '#2889e9';
  public color = '#32bbbc8f';
  dimensions;
  imageMedia = []
  hotspotTransparency: boolean;

  constructor(public maskSvc: MaskingService, public sanitizer: DomSanitizer,
    public router : Router) { }

  ngOnChanges(changes: SimpleChanges): void {
    // console.log(this.questions)
    if (this.svg) {
      this.svg.remove(); // Remove the previous SVG if it exists
    }
    this.createSVG()
    this.closePolygon()
  }

  private createSVG(): void {
    if (this.artboard) {
      this.dimensions = this.maskSvc.getDimensions();
      this.svg = d3.select(this.artboard.nativeElement).append('svg')

      // --------Add your SVG content here------
      this.svg.style('background-size', this.dimensions.width + 'px ' + this.dimensions.height + 'px')
      this.svg.style('height', this.dimensions.canvasHeight + 'px')
      this.svg.style('width', this.dimensions.canvasWidth + 'px')
      this.svg.style('background-image', `url(${this.questions.hotspotMedia})`);
      this.svg.style('background-repeat', 'no-repeat');
      // this.svg.append('rect')
      // .attr('width', '100%')
      // .attr('height', '100%')
      // .attr('fill', 'red');

      this.color = this.questions.questiondescription.outLine;
      this.color1 = this.questions.questiondescription.inLine;
    }
  }

  ngOnInit(): void {
    // this.dimensions = this.maskSvc.getDimensions();
    // this.svg = d3.select('.artboard').append('svg')
    //   .attr('background-size', this.dimensions.width + 'px ' + this.dimensions.height + 'px')
    //   .attr('height', '300px')
    //   .attr('width', '800px')
    //   .attr('fill', 'red')
    // this.svg.style('background-image', `url(${this.questions.hotspotMedia})`);
  }


  ngAfterViewInit(): void {
    this.maskSvc.setArtboard(this.artboard.nativeElement.innerHTML);
    // this.svgElement = this.artboard.nativeElement.children[0];
  }


  public closePolygon(childPoly?: boolean): void {

    this.hotspotTransparency = this.router.url.includes(`tests/`);

    let child = '';
    if (childPoly) {
      child = ' child';
    }

    if (this.svg) {
      this.svg.selectAll('circle').attr('cursor', 'move');
      this.svg.select('g.drawPoly').remove();

      const points = this.questions.options.map(element => element.answerDescription.publicPoints);
      let i = 0;
      for (const point of points) {
        const g = this.svg.append('g').attr('class', this.color + ' completePoly' + child).attr('layerHidden', 'false')
          .attr('color', this.color)
          .attr('opacity', (this.hotspotTransparency && this.questions.isRemoveHotspotColor) ? 0 : 0.8)
          .attr('visibility', 'visible');

        g.append('polygon')
          .attr('points', point)
          .attr('shape-rendering', 'crispEdges')
          .style('fill', this.color)
          .style('opacity', 0.8)
          .attr('stroke-width', '3')
          .attr('stroke', this.color1);

        for (const point1 of point) {
          g.selectAll('circles')
            .data([point1])
            .enter()
            .append('circle')
            .attr('cx', point1[0])
            .attr('cy', point1[1])
            .attr('fill', '#FDBC07')
            .attr('stroke', '#000')
            .attr('is-handle', 'true')
            .attr('class', 'dragCircle')
            .attr('cursor', 'move')
            .call(d3.drag()
              .on('drag', function () {
                // holder.handleDrag(this);
              })
              .on('end', () => {
                // this.addToHistory(this.drawing, this.startPoint, this.g, point);
              })
            );
        }
        i++;

        g.append('circle').attr('points', points[0])
        .attr('cx', point[0][0])
        .attr('cy', point[0][1])
        .attr('fill', 'white')
        .attr('r', 15)
        .attr('stroke', '#000')

        g.append('text').attr('points', points[0])
        .attr('x', point[0][0] - 7)
        .attr('y', point[0][1] + 10)
        .attr('fill', '#4B0082')
        .attr('font-size',25)
        .text(i);
      }
    }
  }

}
